import React, {useState, useRef, useEffect} from 'react';
import RutFactory from 'factories/Rut';
import RadioButton from 'components/RadioButton';
import Modal from "components/Modal";
import PubSub from 'services/PubSub/';
import CartAction from 'actions/Cart';
import { actionsType } from 'config/constants';
import style from './style.scss'; //NOSONAR

let action = [];
let timeout = 0;
const ModalOrderDelivery = () => {

    const [rutValue, setRutValue] = useState('');
    const [rutIsValid, setRutIsValid] = useState(false);
    const [formIsValid, setFormIsValid] = useState(false);
    const [showMessage, setShowMessage] = useState(false);
    const [receiverData, setReceiver] = useState(null);
    const [selected, setSelected] = useState(false);

    let firstName = useRef('');
    let document = useRef('');
    let lastName = useRef('');
    let receiver = '';
    const [payload, setPayload] = useState(null);
    let userDataOF = {}
    if(payload && payload.clientProfileData){
        userDataOF = {
            document: payload.clientProfileData.document,
            firstName: payload.clientProfileData.firstName,
            lastName: payload.clientProfileData.lastName
        }
    }
    useEffect(() => {
        action.push(PubSub.register(actionsType.MODAL.RECEIVER_DATA_OPEN, _open));

        return function cleanup() {
            action.map(token => PubSub.unregister(token));
            action = [];
            timeout = 0
        }
    }, []);


    const _open = (paylo) => {
        setPayload(null);

        setTimeout(()=> {
            setPayload({...paylo.value});
        }, 1);
    }

    useEffect(() => {
        if(payload){

            receiver  = payload.receiverData;

            setRutValue(receiver ? receiver.document : '');

            if(receiver && (receiver.document == payload.clientProfileData.document)){
                receiver.firstName  = '';
                receiver.lastName = '';
                setSelected(false);
                setRutValue('');
            }else{
                setSelected(!!receiver);

            }

            setReceiver(receiver);

            setFormIsValid(true);
            setTimeout(()=>  PubSub.dispatch('cart_update_title', {title: 'Quién recibe'}),0)
        }
    },[payload]);


    useEffect(()=> {
        if(selected && document.current && (document.current.value === userDataOF.document)){
            document.current.value = '';
            firstName.current.value = '';
            lastName.current.value = ''
        }
        validateForm();
    },[selected])

    const validateForm = () => {
        const validRUT = document.current ? validateRut(document.current.value) : '';
        const validNAME = (firstName && firstName.current && firstName.current.value.length>0);
        const validLAST = (lastName && lastName.current && lastName.current.value.length>0)
        const isvalid = validRUT && validNAME && validLAST;
        if (isvalid !== formIsValid) {
            setFormIsValid(isvalid);
        }
        if(!selected){
            setFormIsValid(true)
        }
    }


    const validateRut = (value) => {
        return RutFactory.validateRut(value ? value : '');
    }

    const inputRut = (rut) => {
        const validRutState = validateRut(rut);

        setShowMessage(false);
        setRutValue(rut);
        setRutIsValid(validRutState);
        validateForm();
        clearTimeout(timeout);

        if (validRutState) {
            setShowMessage(false);
        } else {
            timeout = setTimeout(() => {
                setShowMessage(true)
            }, 500);
        }
    }

    const setReceiverData = (e) => {

        let data = {};
        if (!selected) {
            data = userDataOF
        } else {
            data = {
                document: rutValue,
                firstName: firstName.current.value,
                lastName: lastName.current.value
            }
        }
        if(data.firstName && data.lastName && data.document) {
            CartAction.setUserReceiver(data);
            let address = payload ? payload.address : {};
            address.receiverName = data.firstName + " " + data.lastName;
            CartAction.updateShippingData(address).then(() => {
                setTimeout(()=> closeModal(), 200);
            });
        } else {
            setTimeout(()=> closeModal(), 200);
        }

        e.preventDefault();
    }
    const closeModal = () => {

        setTimeout(()=> PubSub.dispatch('cart_update_title', {title: 'Checkout'}),0)
        setTimeout(()=> PubSub.dispatch(actionsType.RECEIVER_DATA_CLOSE),0)
    }

    return(
        <Modal customClass="order-delivery" actionOpen={actionsType.MODAL.RECEIVER_DATA_OPEN} actionClose={actionsType.RECEIVER_DATA_CLOSE}>
            <div className="new-modal-container">
                <div className={"new-modal-title-wrap"}><span className={"new-modal-title"}>Quién recibe</span></div>
                <div className="new-modal-scroll">
                    <div className="split-order-button-radio" onClick={() => {setSelected(false)}}>
                        <RadioButton item={!selected} callbackSelect={() => {setSelected(false)}}/>
                        <span className="order-delivery-to">Yo recibiré el pedido </span>
                    </div>
                    <div className="split-order-button-radio" onClick={() => {setSelected(true)}}>
                        <RadioButton item={selected} callbackSelect={() => {setSelected(true)}}/>
                        <span className="order-delivery-to">Otra persona recibirá el pedido</span>
                    </div>

                    {selected &&
                    <div className="order-delivery-inputs-wrap">
                        <div className="order-delivery-input-wrap-user-name input-wrapper">
                            <span className="order-delivery-input-user-name-title required">Nombre</span>
                            <input className="order-delivery-input-user-name input-default" onBlur={()=>validateForm()} placeholder='' ref={firstName} defaultValue={receiverData ? receiverData.firstName : ''}></input>
                        </div>

                        <div className="order-delivery-input-wrap-last-name input-wrapper">
                            <span className="order-delivery-input-last-name-title required">Apellido</span>
                            <input className="order-delivery-input-last-name input-default " onBlur={()=>validateForm()} placeholder='' ref={lastName} defaultValue={receiverData ? receiverData.lastName : ''}></input>
                        </div>

                        <div className="order-delivery-input-wrap-rut input-wrapper">
                            <span className="order-delivery-input-rut-title required">RUT</span>
                            <input className={"order-delivery-input-rut input-default " + ((!rutIsValid && showMessage) ? ' input-error' : '')} placeholder='' value={rutValue ? rutValue : ''} onBlur={()=>validateForm()} onChange={(e)=>inputRut(e.target.value)} ref={document} maxLength="12"></input>
                            {(!rutIsValid && showMessage) && <i className="jumbo-icon-new-close"></i>}
                            {(!rutIsValid && showMessage) ? <p className="input-error-message">Ingrese un Rut válido</p> : ''}
                        </div>
                    </div>
                    }
                </div>

                <div className="modal-actions">
                    <button onClick={() => closeModal()} className="secundary-btn">Cancelar</button>
                    <button onClick={setReceiverData} className={formIsValid ? "primary-btn" : ' disabled-btn'}>Confirmar</button>
                </div>
            </div>

        </Modal>
    )
}


export default ModalOrderDelivery;
